import { Col, Row } from 'antd';
import React from 'react'
import { Card } from '../../common/UIComponents';
import { renderModifiedGroup, renderRegularGroup } from '../AllOrgActivities/formHelper';
import { groupDifferencesByAction, zonesByDistanceColumns } from '../AllOrgActivities/helper';

export const ZoneByDistanceDetails = ({data}) => {

  const renderEntireGroup = (changes, title, type, columns) => {
    if (!changes?.length) return null;
    return(
      <div>
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
      style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
      }}
      >
        {renderRegularGroup(changes, title, type, columns)}
      </Card>
      </div>
    )
  }

  const renderDetails = () => {
    const incomingData = data?.difference ?? [];
    const incomingAction = data?.action;  
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: incomingData });
    const incomingEntry = incomingData[0]?.new_value ? "New Entry" : "Old Entry";
      return (
      <div className="mt-6">
          <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
              <span style={{ fontSize: '20px', color: '#395484' }}>{`Billing Zones (${_.startCase(_.get(data.difference[0], "zone_type", ""))})`}</span>
              <div className="mt-6">
                  {renderEntireGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED', zonesByDistanceColumns)}
                  {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED', zonesByDistanceColumns)}
                  {renderModifiedGroup(groupedDifferences.MODIFIED, zonesByDistanceColumns, "billingZones")}
              </div>
          </h4>
      </div>
    )
  }

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderDetails()}</Col>
    </Row>
  )
}